/*! @azure/msal-browser v4.23.0 2025-09-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.23.0";

export { name, version };
